import { render, staticRenderFns } from "./CreateEditItem.vue?vue&type=template&id=25089022"
import script from "./CreateEditItem.vue?vue&type=script&lang=js"
export * from "./CreateEditItem.vue?vue&type=script&lang=js"
import style0 from "./CreateEditItem.vue?vue&type=style&index=0&id=25089022&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports